import styled, { css } from 'styled-components';

export const ComboDatePicker = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  p {
    margin: 15px;
  }
`;

export const Container = styled.div`
  width: 100%;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;

  label > svg {
    display: none !important;
    margin: 0;
    padding: 0;
  }
  p {
    font-size: 13px;
  }
  ${({ isOpen }) =>
    isOpen
      ? css`
          height: auto;
          opacity: 1;
        `
      : css`
          height: 0px;
          opacity: 0;
          display: none;
        `}
`;

export const CardFilter = styled.div`
  max-width: 1038px;
  border-radius: 10px;
  background-color: #f2f2f2;
  width: 100%;

  ${({ minHeight }) =>
    minHeight
      ? css`
          min-height: ${minHeight}px;
        `
      : `min-height: 200px;`};
`;
export const CardFilterContent = styled.div`
  min-width: 300px;
  margin: 10px 20px;
  ${({ minHeight }) =>
    minHeight
      ? css`
          min-height: ${minHeight};
        `
      : ``};
`;
export const CardFilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: left;
  padding: 20px 20px 0 25px;
  letter-spacing: 0.32px;
  font-family: 'unimed_slabregular';
  font-weight: bold;
  color: #5a5a5a;
`;
export const CardFilterFooter = styled.div`
  display: flex;
  padding: 0px 20px 10px 20px;
  ${({ justifyContent }) =>
    justifyContent
      ? css`
          justify-content: ${justifyContent};
        `
      : `justify-content: center`};

  ${({ paddingLeft }) =>
    paddingLeft
      ? css`
          padding-left: ${paddingLeft};
        `
      : ``};
  ${({ paddingTop }) =>
    paddingTop
      ? css`
          padding-top: ${paddingTop};
        `
      : ``};

  * {
    margin: 5px;
  }
`;
